import { css } from 'styled-components';

import { CARD_BORDER_RADIUS } from '@sorare/core/src/lib/cards';

export const cardShape = css`
  aspect-ratio: var(--card-aspect-ratio);
  max-width: 150px;
  border-radius: ${CARD_BORDER_RADIUS};
`;
